import { computed, type ComputedRef, isVNode } from 'vue'
import type { Slot, VNodeChild } from 'vue'

const getTextFromNode = (node: VNodeChild): string => {
    if (typeof node === 'string' || typeof node === 'number') {
        return String(node)
    }

    if (!node || typeof node === 'boolean') {
        return ''
    }

    if (Array.isArray(node)) {
        return node.map(getTextFromNode).join(' ')
    }

    if (!isVNode(node)) {
        return ''
    }

    const { children } = node

    if (typeof children === 'string') {
        return children
    }

    if (Array.isArray(children)) {
        return children.map(getTextFromNode).join(' ')
    }

    return ''
}

export const useSlotText = (slot?: Slot): ComputedRef<string> =>
    computed(() =>
        (slot?.() || [])
            .map(getTextFromNode)
            .join(' ')
            .replace(/\s+/g, ' ')
            .trim()
    )
